"use strict";
/**
 * Change-detection helpers comparing a draft schema against the
 * last-committed (saved) one. The hooks expose memoized snapshots that
 * back the visual "is-changed" indicators on group / signal cards.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPropertyChanged = exports.isCategoryChanged = exports.buildSavedPropertyIndex = void 0;
exports.buildSavedPropertyIndex = function (saved) {
    var map = {};
    saved.forEach(function (category) {
        category.properties.forEach(function (property) {
            map[property.id] = {
                categoryId: category.id,
                signature: JSON.stringify(property),
            };
        });
    });
    return map;
};
/**
 * A category is considered "changed" only when its name or its set of
 * property ids differ between draft and saved. We intentionally ignore
 * changes to a property's raw values (e.g. its `useCases` list refreshed
 * from live data) so a group isn't flagged as changed when the user
 * hasn't actually edited anything about it.
 */
exports.isCategoryChanged = function (categoryId, draft, saved) {
    var draftCategory = draft.find(function (c) { return c.id === categoryId; });
    var savedCategory = saved.find(function (c) { return c.id === categoryId; });
    if (!draftCategory || !savedCategory) {
        return true;
    }
    if (draftCategory.name !== savedCategory.name) {
        return true;
    }
    if (draftCategory.properties.length !== savedCategory.properties.length) {
        return true;
    }
    var draftIds = draftCategory.properties.map(function (p) { return p.id; }).sort();
    var savedIds = savedCategory.properties.map(function (p) { return p.id; }).sort();
    return draftIds.some(function (id, i) { return id !== savedIds[i]; });
};
exports.isPropertyChanged = function (property, categoryId, index) {
    var saved = index[property.id];
    if (!saved) {
        return true;
    }
    if (saved.categoryId !== categoryId) {
        return true;
    }
    return saved.signature !== JSON.stringify(property);
};
